import throttleUtility from 'javascripts/modules/util.throttle.js';

class ScrollTo {

	constructor(){
		this.component = document.querySelector('[data-component="scroll-to"]');
    
    this.tabs      = document.querySelectorAll('[data-tabs-trigger]');
    this.topOffset = 0;
		
		if(this.component){		
			this._init();
		}
	}

	_init(){

    // Scroll to section on tab click
    for (let element of this.tabs) {
	    element.addEventListener('click', 
	    	(event) => this._scrollToSection(element, event)
	    );
  	}

  }

  _scrollToSection(element, event){
    event.preventDefault();
    const tabName = element.getAttribute('data-tabs-trigger');
    let   section = document.querySelector(`[id="${tabName}"]`);
    window.scroll({
      top     : section.offsetTop - this.topOffset,
      left    : 0,
      behavior: 'smooth'
    });
  }

}

export const scrollToModule = new ScrollTo();